import { type AxiosInstance } from "axios";
import { type SalesforceConnectionResponse } from "@/features/salesforceIntegration/types";

export const SALESFORCE_CONNECTION_ENDPOINT = "/salesforce/connection/";

/**
 * Salesforce接続状態を取得する（`GET /salesforce/connection/`）。
 */
export const getConnection = async (
  apiClient: AxiosInstance
): Promise<SalesforceConnectionResponse> => {
  const { data } = await apiClient.get<SalesforceConnectionResponse>(
    SALESFORCE_CONNECTION_ENDPOINT
  );
  return data;
};
